import React from 'react';
import ReactSelect from 'react-select';
import classnames from 'classnames';
import { get } from 'lodash';
import { touch } from 'redux-form';
import PropTypes from 'prop-types';
import { t } from '../../../modules/infra/i18n';

const Select = (props) => {
  // there's a bug in redux-form that resets value on onBlur
  // here we disable this event for the input + manually dispatch touch so the input is marked as touched
  // and we can show the error message if needed
  // https://github.com/redux-form/redux-form/issues/2768
  const onBlur = (e) => {
    e.preventDefault();
    props.meta.dispatch(touch(props.meta.form, props.input.name));
  };

  const value = get(props, 'input.value', null);
  if (value && !value.label) {
    const option = (props.options || []).find((o) => o.value === value.value);
    if (option) {
      value.label = option.label;
    }
  }

  return (
    <div className="u-position-relative">
      <ReactSelect
        isSearchable={false}
        defaultValue={props.defaultValue}
        options={props.options}
        className={classnames('c-react-select', props.className)}
        classNamePrefix="c-react-select"
        {...props.input}
        placeholder={props.placeholder || t('settings:modern_select.placeholder')}
        onChange={props.input.onChange}
        onFocus={props.input.onFocus}
        value={value}
        {...props.meta}
        onBlur={onBlur}
      />
      <div className="c-input-error-message" display-if={props.meta.touched && props.meta.error}>
        {props.meta.error}
      </div>
    </div>
  );
};

Select.propTypes = {
  defaultValue: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  options: PropTypes.array,
  className: PropTypes.string,
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
};

Select.defaultProps = {
  defaultValue: null,
  options: [],
  className: '',
};

const SelectComponent = Select;

export default SelectComponent;
